import { useQuery } from "@apollo/client";
import { GET_KURSUSHOLD_KORRESPONDANCE_BY_ID_QUERY } from "../../../../api/kursus/queries";
import { defaultKursusKorrespondanceColumns } from "../../../../config/kursusConfig";
import useActiveColumns from "../../../../hooks/useActiveColumns";
import { AccordionCard } from "../../../accordion/Accordion";
import KorrespondanceTable from "./Korrespondance/KorrespondanceTable";
import Spinner from "../../../spinner/Spinner";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "../../../ErrorFallback";
import useLocalStorageState from "use-local-storage-state";
import { KursusholdKorrespondance } from "../../../../interfaces/schema";

export default function KursusKorrespondance({
  kursusholdId,
}: {
  kursusholdId: string;
}) {
  const [, setTabs] = useLocalStorageState("kursus-id-tabs");
  const [kursusKorrespondanceColumns, setKursusKorrespondanceActiveColumns] =
    useActiveColumns(
      "kursus-personkorrespondance-active-columns",
      defaultKursusKorrespondanceColumns,
    );

  const { loading, error, data, refetch } = useQuery<{
    kursushold: {
      kursusKorrespondance: KursusholdKorrespondance[];
    };
  }>(GET_KURSUSHOLD_KORRESPONDANCE_BY_ID_QUERY(), {
    variables: { id: kursusholdId },
  });

  if (loading) return <Spinner />;
  if (error) return <div>noget gik galt 😔</div>;
  if (!data?.kursushold?.kursusKorrespondance || !kursusholdId) return null;

  const {
    kursushold: { kursusKorrespondance },
  } = data;

  return (
    <div className="container">
      <ErrorBoundary
        FallbackComponent={ErrorFallback}
        onReset={() => setTabs("stamoplysninger")}
      >
        <AccordionCard
          title="Korrespondance"
          value="korrespondance"
          isEmpty={!kursusKorrespondance.length}
          localstorageKey="kursus-id-stamoplysninger-accordion-value"
        >
          <KorrespondanceTable
            columns={kursusKorrespondanceColumns}
            setActiveColumns={setKursusKorrespondanceActiveColumns}
            kursusId={kursusholdId}
            kursusKorrespondance={kursusKorrespondance}
            invalidateData={refetch}
          />
        </AccordionCard>
      </ErrorBoundary>
    </div>
  );
}
